import './product-promo.component.pug'
import './product-promo.component.scss'

if (!document.documentElement.classList.contains('touchevents')) {
  import(
    /* webpackChunkName: "interactiveFabric" */ '../../application/interactiveFabric'
  ).then(({ TweenLite }) => {
    document.querySelectorAll('.product-promo').forEach((root) => {
      const background = root.querySelector('.product-promo-wrapper')
      const image = root.querySelector('.product-promo-image')
      root.addEventListener('mousemove', (e) => {
        TweenLite.to(
          background,
          {
            backgroundPositionX: `${(e.clientX / window.innerWidth) * 30}%`
          },
          1
        )
        TweenLite.to(
          image,
          {
            translateX: `${(e.clientX / window.innerWidth) * 2 - 1}%`
          },
          1
        )
      })
    })
  })
}
